export const colorPairs = [
    { primary: "firebrick", secondary: "darkorange" },
    { primary: "darkorange", secondary: "yellow" },
    { primary: "darkgoldenrod", secondary: "gold" },
    { primary: "seagreen", secondary: "limegreen" },
    { primary: "royalblue", secondary: "mediumturquoise" },
    { primary: "blueviolet", secondary: "orchid" },
    { primary: "teal", secondary: "skyblue" },
];
